module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": _vm.pageTitle,
      "back-route": "event.index"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__search_list box-card",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.onFilterClean
    }
  }, [_vm._v("Limpar todos filtros")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Matrícula"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Filtrar por Matrícula"
    },
    model: {
      value: (_vm.filters.ref_pessoa),
      callback: function($$v) {
        _vm.$set(_vm.filters, "ref_pessoa", $$v)
      },
      expression: "filters.ref_pessoa"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Filtrar por Nome"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Evento"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por evento",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.sub_event),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sub_event", $$v)
      },
      expression: "filters.sub_event"
    }
  }, _vm._l((_vm.listEvents), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Campus"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por campus",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.campus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "campus", $$v)
      },
      expression: "filters.campus"
    }
  }, _vm._l((_vm.listCampus), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Curso"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por curso",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.course),
      callback: function($$v) {
        _vm.$set(_vm.filters, "course", $$v)
      },
      expression: "filters.course"
    }
  }, _vm._l((_vm.listCourse), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por status",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, _vm._l((_vm.listStatus), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Instituição"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por Instituição",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.institution),
      callback: function($$v) {
        _vm.$set(_vm.filters, "institution", $$v)
      },
      expression: "filters.institution"
    }
  }, _vm._l((_vm.listInstitution), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "advisors-urcamp",
      "label": "Orientadores da URCAMP"
    }
  }, [(_vm.activeTab === 'advisors-urcamp') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "authors-students-urcamp",
      "label": "Alunos Autores ou Coautores"
    }
  }, [(_vm.activeTab === 'authors-students-urcamp') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "authors-professors-urcamp",
      "label": "Professors Autores ou Coautores"
    }
  }, [(_vm.activeTab === 'authors-professors-urcamp') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "registrations-fies",
      "label": "Inscritos FIES"
    }
  }, [(_vm.activeTab === 'registrations-fies') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "registrations-prouni",
      "label": "Inscritos Prouni"
    }
  }, [(_vm.activeTab === 'registrations-prouni') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "registrations-course-campus",
      "label": "Inscritos por Curso e Campus"
    }
  }, [(_vm.activeTab === 'registrations-course-campus') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Campus")]), _vm._v(" "), _c('th', [_vm._v("Curso")]), _vm._v(" "), _c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Status Inscrição")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.campus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.curso))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "submissions",
      "label": "Trabalhos"
    }
  }, [(_vm.activeTab === 'submissions') ? _c('div', [_c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Estatísticas da Triagem")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Não Atribuídos")]), _vm._v(" "), _c('th', [_vm._v("Aprovados")]), _vm._v(" "), _c('th', [_vm._v("Reprovados")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nao_designado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.aprovado_pela_triagem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.reprovado_pela_triagem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nao_designado + item.aprovado_pela_triagem + item.reprovado_pela_triagem))])])
  })), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Estatísticas da Avaliação")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Em Avaliação")]), _vm._v(" "), _c('th', [_vm._v("Aprovados")]), _vm._v(" "), _c('th', [_vm._v("Reprovados")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.em_avaliacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.avaliado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.reprovado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.em_avaliacao + item.avaliado + item.reprovado))])])
  }))])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "submissions-event-area-city",
      "label": "Trabalhos por Evento, Área, Cidade"
    }
  }, [(_vm.activeTab === 'submissions-event-area-city') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Área")]), _vm._v(" "), _c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', [_vm._v("Título")]), _vm._v(" "), _c('th', [_vm._v("Autor")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Instituição")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.area_conhecimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.instituicao))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "event-participants",
      "label": "Participantes do Evento"
    }
  }, [(_vm.activeTab === 'event-participants') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Inscrição Nº")]), _vm._v(" "), _c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', [_vm._v("Cidade/Estado")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.registration))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.social_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.city) + "/" + _vm._s(item.state))])])
  }))]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25cf0091!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/reports/ReportsAdmin.vue
// module id = 729
// module chunks = 2